class SPModalObserver {

    _currentScroll = 0;
    _locked = false;

    constructor() {

        this._initObservers();
    }

    _initObservers() {

        this._Observer = new MutationObserver( ( mutation ) => {

            var classList = mutation[0].target.classList;
            if( classList.contains( 'no-scroll' ) ) {
                // Prevent scroll
                if( ENV.template == 'mobile' ) {
                    this._locked = true;
                    this._currentScroll = window.pageYOffset;
                    document.body.style.position = 'fixed';
                }
            } else {
                // Enable scroll
                if( ENV.template == 'mobile' && this._locked == true ) {
                    this._locked = false;
                    document.body.style.position = 'relative';
                    TweenMax.set(window, { scrollTo: { y: this._currentScroll } });
                }
            }

        });

        this._Observer.observe( document.body, {
            attributes: true,
            attributeFilter: ['class']
        });

    }
}

export default new SPModalObserver();



// WEBPACK FOOTER //
// ./src/js/helpers/modal-observer.js